import { createReducer } from '@panel/commons/redux';
import * as types from './types';

const initialStateIntegrations = {
  companies: {
    data: [],
    loading: false,
    error: null,
    fetched: false
  },
  integrators: {
    data: [],
    loading: false,
    type: null,
    error: null
  },
  companyIntegrations: {
    data: null,
    loading: false,
    error: null,
    fetched: false
  },
  activation: {
    data: null,
    loading: false,
    error: null
  },
  deactivation: {
    data: null,
    loading: false,
    error: null
  },
  loading: false
};

const integrationsReducer = createReducer(initialStateIntegrations)({
  [types.GET_SUB_COMPANIES]: state => ({ ...state, companies: { data: [], loading: true, error: null } }),
  [`${types.GET_SUB_COMPANIES}_COMPLETED`]: (state, action) => ({
    ...state,
    companies: { ...state.companies, data: action.payload, loading: false, fetched: true }
  }),
  [`${types.GET_SUB_COMPANIES}_FAILED`]: (state, action) => ({
    ...state,
    companies: { ...state.companies, error: action.payload, loading: false }
  }),
  [types.LIST_INTEGRATORS]: (state, action) => ({
    ...state,
    integrators: { data: [], loading: true, error: null, type: action.payload.integrationType }
  }),
  [`${types.LIST_INTEGRATORS}_COMPLETED`]: (state, action) => ({
    ...state,
    integrators: { ...state.integrators, data: action.payload, loading: false }
  }),
  [`${types.LIST_INTEGRATORS}_FAILED`]: (state, action) => ({
    ...state,
    integrators: { ...state.integrators, error: action.payload, loading: false }
  }),
  [types.UPSERT_INTEGRATION]: state => ({
    ...state,
    activation: { data: null, loading: true, error: null },
    loading: true
  }),
  [`${types.UPSERT_INTEGRATION}_COMPLETED`]: (state, action) => ({
    ...state,
    activation: { ...state.activation, data: action.payload, loading: false },
    loading: false
  }),
  [`${types.UPSERT_INTEGRATION}_FAILED`]: (state, action) => ({
    ...state,
    activation: { ...state.activation, error: action.payload, loading: false },
    loading: false
  }),
  [types.REMOVE_XML_INTEGRATION]: state => ({
    ...state,
    deactivation: { data: null, loading: true, error: null },
    loading: true
  }),
  [`${types.REMOVE_XML_INTEGRATION}_COMPLETED`]: (state, action) => ({
    ...state,
    deactivation: { ...state.deactivation, data: action.payload, loading: false },
    loading: false
  }),
  [`${types.REMOVE_XML_INTEGRATION}_FAILED`]: (state, action) => ({
    ...state,
    deactivation: { ...state.deactivation, error: action.payload, loading: false },
    loading: false
  }),
  [types.GET_CURRENT_INTEGRATION]: state => ({
    ...state,
    companyIntegrations: { data: null, loading: true, error: null, fetched: true }
  }),
  [`${types.GET_CURRENT_INTEGRATION}_COMPLETED`]: (state, action) => ({
    ...state,
    companyIntegrations: {
      ...state.companyIntegrations,
      data: action.payload,
      loading: false
    }
  }),
  [`${types.GET_CURRENT_INTEGRATION}_FAILED`]: (state, action) => ({
    ...state,
    companyIntegrations: { ...state.companyIntegrations, error: action.payload, loading: false }
  }),
  [types.CLEAR_CURRENT_INTEGRATION]: state => ({
    ...state,
    companyIntegration: { data: null, loading: false, error: null }
  })
});

const initialStateLeadsIntegrations = {
  companies: {
    data: [],
    loading: false,
    error: null
  },
  integrators: {
    data: [],
    loading: false,
    error: null
  },
  companyIntegrations: {
    data: null,
    loading: false,
    error: null
  },
  activation: {
    data: null,
    loading: false,
    error: null
  },
  deactivation: {
    data: null,
    loading: false,
    error: null
  },
  loading: false
};

const leadsIntegrationsReducer = createReducer(initialStateLeadsIntegrations)({
  [types.LIST_LEADS_INTEGRATORS]: state => ({ ...state, integrators: { data: [], loading: true, error: null } }),
  [`${types.LIST_LEADS_INTEGRATORS}_COMPLETED`]: (state, action) => ({
    ...state,
    integrators: { ...state.integrators, data: action.payload, loading: false }
  }),
  [`${types.LIST_LEADS_INTEGRATORS}_FAILED`]: (state, action) => ({
    ...state,
    integrators: { ...state.integrators, error: action.payload, loading: false }
  }),
  [types.GET_LEADS_COMPANY_BRANCHES]: state => ({
    ...state,
    companies: { data: [], loading: true, error: null }
  }),
  [`${types.GET_LEADS_COMPANY_BRANCHES}_COMPLETED`]: (state, action) => ({
    ...state,
    companies: { ...state.companies, data: action.payload, loading: false }
  }),
  [`${types.GET_LEADS_COMPANY_BRANCHES}_FAILED`]: (state, action) => ({
    ...state,
    companies: { ...state.companies, error: action.payload, loading: false }
  }),
  [types.GET_CURRENT_LEADS_INTEGRATIONS]: state => ({
    ...state,
    companyIntegrations: { data: null, loading: true, error: null }
  }),
  [`${types.GET_CURRENT_LEADS_INTEGRATIONS}_COMPLETED`]: (state, action) => ({
    ...state,
    companyIntegrations: { ...state.companyIntegrations, data: action.payload, loading: false }
  }),
  [`${types.GET_CURRENT_LEADS_INTEGRATIONS}_FAILED`]: (state, action) => ({
    ...state,
    companyIntegrations: { ...state.companyIntegrations, error: action.payload, loading: false }
  }),
  [types.ADD_LEADS_INTEGRATION]: state => ({
    ...state,
    activation: { data: null, loading: true, error: null },
    loading: true
  }),
  [`${types.ADD_LEADS_INTEGRATION}_COMPLETED`]: (state, action) => ({
    ...state,
    activation: { ...state.activation, data: action.payload, loading: false },
    loading: false
  }),
  [`${types.ADD_LEADS_INTEGRATION}_FAILED`]: (state, action) => ({
    ...state,
    activation: { ...state.activation, error: action.payload, loading: false },
    loading: false
  }),
  [types.REMOVE_LEADS_INTEGRATION]: state => ({
    ...state,
    deactivation: { data: null, loading: true, error: null },
    loading: true
  }),
  [`${types.REMOVE_LEADS_INTEGRATION}_COMPLETED`]: (state, action) => ({
    ...state,
    deactivation: { ...state.deactivation, data: action.payload, loading: false },
    loading: false
  }),
  [`${types.REMOVE_LEADS_INTEGRATION}_FAILED`]: (state, action) => ({
    ...state,
    deactivation: { ...state.deactivation, error: action.payload, loading: false },
    loading: false
  }),
  [types.CLEAR_CURRENT_LEADS_INTEGRATIONS]: state => ({
    ...state,
    companyIntegrations: { data: null, loading: false, error: null }
  }),
  [types.CLEAR_ADDED_LEADS_INTEGRATION]: state => ({
    ...state,
    activation: { data: null, loading: false, error: null }
  }),
  [types.CLEAR_REMOVED_LEADS_INTEGRATION]: state => ({
    ...state,
    deactivation: { data: null, loading: false, error: null }
  })
});

export { integrationsReducer, leadsIntegrationsReducer };
